import React from 'react';

const RequiredFieldIndicator: React.FC = () => (
    <span style={{ color: '#ff5733' }}>*</span>
  );  

export default RequiredFieldIndicator;
